import React from 'react';
import error from '../../assets/images/error-boundary.svg';
import { SvgIconProps } from '@mui/material';

export const AfDisconnectedIcon: React.FC<SvgIconProps> = () => {
  return <img src={error} />;
};
